/* global debounce, trapFocus */
// ---- Apply discount on cart feature ----
  // ─── Cart Discount State ───
  window.cartDiscountState = window.cartDiscountState || { appliedDiscounts: [] };

  async function loadExistingDiscountsOnce() {
    const response = await fetch('/cart.js');
    const data = await response.json();
    window.cartDiscountState.appliedDiscounts = data.discount_codes
      .filter((d) => d.applicable)
      .map((d) => d.code);
  }

  function initCartDiscount() {
    const sectionEl = document.getElementById('cart-items');
    console.log('initCartDiscount fired');//temp
    console.log('sectionEl:', sectionEl);//temp
    console.log('SECTION_ID:', sectionEl ? sectionEl.dataset.section : 'NOT FOUND');//temp


    const SECTION_ID = sectionEl ? sectionEl.dataset.section : null;
    if (!SECTION_ID) {
      console.log('❌ Early exit — no SECTION_ID found');//temp
      return;
    }

    const state = window.cartDiscountState;

    // ─── Apply Discount ───
    async function applyDiscount(discountCode) {
      if (state.appliedDiscounts.includes(discountCode)) {
        return { success: false, reason: 'already_applied' };
      }

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: [...state.appliedDiscounts, discountCode].join(','),
          sections: [SECTION_ID],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      console.log(data);//temp
      console.log('discount_codes:', data.discount_codes);//temp
      console.log('cart_level_discount_applications:', data.cart_level_discount_applications);//temp

      const discountResult = data.discount_codes.find(
        (discount) => discount.code === discountCode
      );

      if (!discountResult || discountResult.applicable === false) {
        return { success: false, reason: 'not_applicable' };
      }

      state.appliedDiscounts.push(discountCode);
      return { success: true, data };
    }

    // ─── Remove Discount ───
    async function removeDiscount(discountCode) {
      state.appliedDiscounts = state.appliedDiscounts.filter((code) => code !== discountCode);

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: state.appliedDiscounts.join(','),
          sections: [SECTION_ID],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      return { success: true, data };
    }

    // ─── Update Cart Section ───
    function updateCartSection(data) {
      const sectionHtml = data.sections[SECTION_ID];
      if (!sectionHtml) return;

      const parser = new DOMParser();
      const parsedHtml = parser.parseFromString(sectionHtml, 'text/html');

      const cartDrawer = document.getElementById('cart-drawer');

      if (cartDrawer) {
        // ─── Update full cart drawer summary ───
        const newSummary = parsedHtml.querySelector('.cart-drawer__summary');
        const currentSummary = document.querySelector('.cart-drawer__summary');
        if (newSummary && currentSummary) {
          currentSummary.innerHTML = newSummary.innerHTML;
          initCartDiscount(); // re-attach listeners after summary replaced
          renderPills();
          return;
        }

        // ─── Fallback: update just .cart__summary ───
        const newCartSummary = parsedHtml.querySelector('.cart__summary');
        const currentCartSummary = document.querySelector('.cart__summary');
        if (newCartSummary && currentCartSummary) {
          currentCartSummary.innerHTML = newCartSummary.innerHTML;
          initCartDiscount();
          renderPills();
        }


        // // On drawer: only update summary, don't wipe drawer items
        // const newSummary = parsedHtml.querySelector('.cart__summary');
        // const currentSummary = document.querySelector('.cart__summary');
        // if (newSummary && currentSummary) {
        //   currentSummary.innerHTML = newSummary.innerHTML;
        // }
      } else {
        // On cart page: safe to replace full section
        const newSection = parsedHtml.getElementById(`shopify-section-${SECTION_ID}`);
        const currentSection = document.getElementById(`shopify-section-${SECTION_ID}`);
        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
        }
      }

      // const newSection = parsedHtml.getElementById(`shopify-section-${SECTION_ID}`);
      // const currentSection = document.getElementById(`shopify-section-${SECTION_ID}`);

      // if (newSection && currentSection) {
      //   currentSection.innerHTML = newSection.innerHTML;
      // }

      // Re-init after DOM replaced, then render pills
      initCartDiscount();
      renderPills();
    }

    // ─── Render Pills ───
    function renderPills() {
      const pillsContainer = document.getElementById('discount-pills');
      if (!pillsContainer) return;

      pillsContainer.innerHTML = '';

      state.appliedDiscounts.forEach((code) => {
        const li = document.createElement('li');
        li.dataset.discountCode = code;
        li.innerHTML = `
          <span>${code}</span>
          <button type="button" class="remove-discount" data-code="${code}">✕</button>
        `;
        pillsContainer.appendChild(li);
      });
    }

    // ─── Apply Button ───
    const applyBtn = document.getElementById('apply-discount-btn');
    console.log('Has apply btn'); //temp
    console.log('applyBtn:', applyBtn);//temp
    console.log('applyBtn listenerAttached:', applyBtn?.dataset.discountListenerAttached);//temp

    if (applyBtn && !applyBtn.dataset.discountListenerAttached) {
      applyBtn.dataset.discountListenerAttached = 'true';

      applyBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        console.log('Clicked apply btn'); //temp

        const input = document.getElementById('discount-input');
        const message = document.getElementById('discount-message');
        const code = input.value.trim().toUpperCase();

        if (!code) return;

        message.textContent = 'Checking...';

        const result = await applyDiscount(code);

        if (result.success) {
          message.textContent = '✅ Discount applied!';
          clearMessage(message);
          updateCartSection(result.data);
          input.value = '';
        } else if (result.reason === 'already_applied') {
          message.textContent = '⚠️ Discount already applied.';
          clearMessage(message);
        } else {
          message.textContent = '❌ This discount code is not valid.';
          clearMessage(message);
          input.value = '';
        }
      });
    }

    // ─── Pills Remove Button ───
    const pillsContainer = document.getElementById('discount-pills');
    console.log('pillsContainer:', pillsContainer);//temp
    if (pillsContainer && !pillsContainer.dataset.discountListenerAttached) {
      pillsContainer.dataset.discountListenerAttached = 'true';

      pillsContainer.addEventListener('click', async (e) => {
        const button = e.target.closest('.remove-discount');
        if (!button) return;

        const code = button.dataset.code;
        const message = document.getElementById('discount-message');

        message.textContent = 'Removing...';

        const result = await removeDiscount(code);

        if (result.success) {
          message.textContent = '✅ Discount removed.';
          clearMessage(message);
          updateCartSection(result.data);
        }
      });
    }

    function clearMessage(message) {
      setTimeout(()=> {
        message.textContent = '';
      },8000);
    }
    // Render pills with current state on every init
    renderPills();
  }




if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.currentQuantities = [];
      try {
        this.querySelectorAll('.cart-item').forEach((item) => {
          this.currentQuantities[item.dataset.variantId] = Number(item.querySelector('.qty-input__input').value);
        });
      } catch (e) {}

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', debounce(this.handleChange.bind(this)));

      // ---- Apply discount on cart feature ----
      if (!this.cartDrawer) {  // only on cart page, not drawer
        loadExistingDiscountsOnce().then(() => initCartDiscount());
      }
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-remove-item')) return;
      evt.preventDefault();
      console.log('1 handle click qty'); //temp
      this.updateQuantity(evt.target.dataset.index, 0);
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      console.log('2 handle click qty'); //temp
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
      console.log('updateQuantity'); //temp
      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      // clear all errors except this line's (which will be refreshed after this update)
      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
      this.fetchRequestOpts.body = JSON.stringify({
        line,
        quantity,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
        const variantId = Number(lineItem.dataset.variantId);
        const oldTotalQuantity = this.currentTotalItemCount;
        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          // We're on the Cart page
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartSummary = document.getElementById('cart-summary');
          if (cartSummary) cartSummary.hidden = true;
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
        });

        // ─── Apply discount on cart feature ───
        initCartDiscount(); // run for both cart page and drawer

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);
        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity: this.currentQuantities[variantId],
              newQuantity: Number(quantity)
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:line-item:quantity', {
            bubbles: true,
            detail: {
              variantId,
              quantity: Number(quantity)
            }
          }));
        }

        this.currentQuantities[variantId] = Number(quantity);

        lineErrors.innerHTML = '';
        lineErrors.hidden = true;
      } catch (error) {
        if (/^[0-9]+$/.test(error.message)) {
          lineErrors.textContent = theme.strings.cartError;
        } else {
          lineErrors.textContent = error.message;
        }
        lineErrors.hidden = false;
        console.log(error); // eslint-disable-line //temp

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        input.value = input.dataset.initialValue;
        input.closest('quantity-input').currentQty = input.dataset.initialValue;
      } finally {
        this.classList.remove('pointer-events-none');

        // Attempt to maintain the same scroll position in the cart drawer
        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh( updateRecom = true) {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        // ─── Apply discount on cart feature ───
        initCartDiscount(); // run for both cart page and drawer

        const firstCartItem = this.querySelector('.cart-item:first-child');
        if (firstCartItem) {
          this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);
        }
        
        errors.innerHTML = '';
        errors.hidden = true;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line //temp

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary')?.dataset.section,
            selector: '.cart__summary'
          }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      // Disable Checkout Button
      var checkoutBtn = document.querySelector('[name="checkout"]');
      if( checkoutBtn ) {
        checkoutBtn.disabled = true;
      }

      var dynamicCheckoutEl = document.querySelectorAll('.dynamic-cart-btns');
      if( dynamicCheckoutEl ) {
        dynamicCheckoutEl.forEach( el => {
          el.classList.add('disabled');
        });
      }

      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');

    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  


  customElements.define('cart-items', CartItems);
}
